/* eslint-disable @typescript-eslint/no-explicit-any */
import wkx from 'wkx';
import buffer from 'buffer';

export const convertToGeometry = (
  geoJSON: any
): wkx.Geometry => {
  return wkx.Geometry.parseGeoJSON(geoJSON);
};

export const geoJsonToWKT = (geoJSON: any): string => {
  const geometry = convertToGeometry(geoJSON);
  return geometry.toWkt();
};

export const geoJsonToWKB = (geoJSON: any): Buffer => {
  const geometry = convertToGeometry(geoJSON);
  return geometry.toWkb();
};

export const wkbbufferFormat = (
  geoJSON: any
): ArrayBuffer => {
  const wkb = geoJsonToWKB(geoJSON);
  return new Uint8Array(wkb).buffer;
};

export const getWKBFormat = (geoJSON: any): string => {
  const buffer = wkbbufferFormat(geoJSON);
  return wkbBuf2hexConversion(buffer);
};

export const getWKBArrayFormat = (
  hex: string
): number[] => {
  const typedArray = new Uint8Array(
    hex
      ?.match(/[\da-f]{2}/gi)
      ?.map((h) => parseInt(h, 16)) || []
  );
  return Object.keys(typedArray).map(
    (data) => typedArray[Number(data)]
  );
};

export const getWKBToGeoJSON = (hex: string): any => {
  const wkbArray = getWKBArrayFormat(hex);
  const geometry = wkx.Geometry.parse(
    buffer.Buffer.from(wkbArray)
  );
  return geometry?.toGeoJSON();
};

export const latLngConversion = (
  hex: string
): { type: string | undefined; geometry: any } => {
  const geoJson = getWKBToGeoJSON(hex);
  const type = geoJson?.type;
  let payload: any = null;

  if (type === 'Point') {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const [lng, lat] = geoJson?.coordinates;
    payload = { lat, lng };
  } else if (type === 'Polygon') {
    const array: { lat: number; lng: number }[] = [];
    const coordinates = geoJson?.coordinates?.[0];
    if (coordinates?.length > 0) {
      coordinates.forEach((element: [number, number]) => {
        const latlngObj = {
          lat: element[1],
          lng: element[0],
        };
        array.push(latlngObj);
      });
    }
    payload = array;
  } else if (type === 'MultiPolygon') {
    payload = geoJson;
  } else if (type === 'LineString') {
    const array: { lat: number; lng: number }[] = [];
    const coordinates = geoJson?.coordinates;
    if (coordinates?.length > 0) {
      coordinates.forEach((element: [number, number]) => {
        const latlngObj = {
          lat: element[1],
          lng: element[0],
        };
        array.push(latlngObj);
      });
    }
    payload = array;
  }

  return { type, geometry: payload };
};

// Helper function for WKB buffer to hex conversion
export const wkbBuf2hexConversion = (
  buffer: ArrayBuffer
): string => {
  return Array.prototype.map
    .call(new Uint8Array(buffer), (x) =>
      ('00' + x.toString(16)).slice(-2)
    )
    .join('');
};
